import {UserType} from "../../../types/user/user-type";

export const convertUserType = (rawValue?: string) => {
    if (!rawValue || !Object.values(UserType).includes(rawValue as UserType)) {
        return UserType.User;
    }
    return rawValue as UserType;
}
